import { CardData } from 'data/types/CardData';
import { CardButtonContent } from './CardButtonContent';

export const CardButton = ({
  cardData,
  onClick,
  hideName = false,
  size = 'medium',
  style = {},
}: {
  cardData: CardData;
  size?: 'small' | 'medium';
  onClick?: () => void;
  hideName?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <button
      key={cardData?.id}
      style={{
        borderRadius: '12px',
        border: 'none',
        cursor: 'pointer',
        position: 'relative',
        padding: 0,
        background: 'transparent',
        ...style,
      }}
      onClick={onClick}
    >
      <CardButtonContent cardData={cardData} hideName={hideName} size={size} />
    </button>
  );
};
